<script>
import { required } from "vuelidate/lib/validators";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import i18n from "@/i18n";

const API_BASE =
  process.env.VUE_APP_API_URI || process.env.API_URI || "https://admin.aicoiot.beer/api.php";

export default {
  page() {
    return {
      title: this.$t("login.login"),
    };
  },
  data() {
    return {
      logoImg: require("@/assets/images/mainlogo_darkgree_web.png"),
      username: "",
      email: "",
      password: "",
      submitted: false,
      extendvoid: false,
      qrcodelogin: false,
      inputList: ["", "", "", "", "", ""],
      authcodes: "",
      keyboard: false,
      ismobile: false,
      loading: false,
      loginLoading: false,
      counter: 0,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  beforeDestroy() {
    document.body.classList.remove("auth-body-bg");
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    const languagecode = (navigator.language || "zh").substr(0, 2);
    i18n.locale = languagecode;
  },
  validations: {
    email: { required },
    password: { required },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    tryToLogIn() {
      const that = this;
      that.submitted = true;
      that.$v.$touch();
      if (that.$v.$invalid) return;
      that.loginLoading = true;
      that.$axios
        .post(API_BASE, {
          action: "login",
          username: that.email,
          password: that.password,
        })
        .then(function (response) {
          that.loginLoading = false;
          if (response.data.status === 403) {
            that.toast(that.$t("login.needauth"));
            that.extendvoid = true;
            that.keyboard = true;
            that.isAuthError = true;
            that.$nextTick(() => {
              const el = document.querySelector(".border-input");
              if (el) el.focus();
            });
          } else if (response.data.status === 200) {
            localStorage.setItem("user", JSON.stringify(response.data.data));
            that.tryingToLogIn = false;
            that.isAuthError = false;
            that.$router.push(
              that.$route.query.redirectFrom || { name: "home" }
            );
          } else {
            that.toast(that.$t("login.loginerror"));
            that.isAuthError = true;
          }
        })
        .catch(function () {
          that.loginLoading = false;
          that.toast(that.$t("login.loginerror"));
        });
    },
    tryToLogInExtend() {
      const authcode = this.ismobile
        ? this.authcodes
        : this.inputList.join("");
      const that = this;
      that.submitted = true;
      that.$v.$touch();
      if (that.$v.$invalid) return;
      that.loading = true;
      that.$axios
        .post(API_BASE, {
          action: "login",
          username: that.email,
          password: that.password,
          authkey: authcode,
        })
        .then(function (response) {
          that.loading = false;
          if (response.data.status === 403) {
            that.toast(that.$t("login.needauth"));
            that.isAuthError = true;
          } else if (response.data.status === 200) {
            localStorage.setItem("user", JSON.stringify(response.data.data));
            that.tryingToLogIn = false;
            that.isAuthError = false;
            that.$router.push(
              that.$route.query.redirectFrom || { name: "home" }
            );
          } else {
            that.toast(that.$t("login.loginerror"));
            that.isAuthError = true;
          }
        })
        .catch(function () {
          that.loading = false;
          that.toast(that.$t("login.loginerror"));
        });
    },
    nextFocus(ev, index) {
      const numRe = /^[0-9]$/;
      if (!numRe.test(ev.key) && ev.keyCode !== 8) return;
      const dom = document.querySelectorAll(".border-input");
      const currInput = dom[index];
      const nextInput = dom[index + 1];
      const lastInput = dom[index - 1];
      if (ev.keyCode !== 8) {
        if (index < this.inputList.length - 1 && nextInput) {
          nextInput.focus();
        } else {
          currInput && currInput.blur();
          this.tryToLogInExtend();
        }
      } else if (index > 0 && lastInput) {
        lastInput.focus();
      }
    },
    onInput(key) {
      this.authcodes = (this.authcodes + key).slice(0, 6);
      if (this.authcodes.length === 6) this.tryToLogInExtend();
    },
    onDelete() {
      this.authcodes = this.authcodes.slice(0, -1);
    },
    toast(text, append = false) {
      this.counter++;
      this.$bvToast.toast(text, {
        title: this.$t("login.alter"),
        toaster: "b-toaster-top-center",
        solid: true,
        appendToast: append,
      });
    },
  },
};
</script>

<template>
  <div class="login-page login-page--centered">
    <div class="home-btn d-none d-sm-block">
      <a href="/" class="text-white">
        <i class="ri-home-4-line h4"></i>
      </a>
    </div>
    <div class="login-page__bg">
      <div class="bg-overlay"></div>
    </div>
    <div class="login-page__center d-flex align-items-center justify-content-center min-vh-100 p-4">
      <div class="login-page__card-wrap">
        <div class="login-card">
                    <div class="text-center mb-4">
                      <a href="/" class="d-inline-block">
                        <img
                          :src="logoImg"
                          alt="logo"
                          class="login-logo"
                        />
                      </a>
                      <h4 class="login-title mt-4">
                        {{ $t("login.login") }}
                      </h4>
                      <p class="login-subtitle" v-if="!extendvoid">
                        {{ $t("login.passwordlogin") }}
                      </p>
                      <p class="login-subtitle" v-else>
                        {{ $t("login.inputcode") }}
                      </p>
                    </div>

                    <b-alert
                      variant="danger"
                      class="mt-3"
                      v-if="notification && notification.message"
                      show
                      dismissible
                      >{{ notification.message }}</b-alert
                    >

                    <!-- 账号密码登录 -->
                    <div class="p-0 mt-4" v-if="!extendvoid && !qrcodelogin">
                      <form class="form-horizontal" @submit.prevent="tryToLogIn">
                        <div class="form-group auth-form-group-custom mb-4">
                          <i class="ri-user-3-line auti-custom-input-icon"></i>
                          <label for="username">{{
                            $t("login.username.text")
                          }}</label>
                          <input
                            type="text"
                            v-model="email"
                            class="form-control"
                            id="username"
                            :placeholder="$t('login.username.placeholder')"
                            :class="{ 'is-invalid': submitted && $v.email.$error }"
                          />
                          <div
                            v-if="submitted && $v.email.$error"
                            class="invalid-feedback d-block"
                          >
                            {{ $t("login.username.noinput") }}
                          </div>
                        </div>

                        <div class="form-group auth-form-group-custom mb-4">
                          <i class="ri-lock-2-line auti-custom-input-icon"></i>
                          <label for="userpassword">{{
                            $t("login.password.text")
                          }}</label>
                          <input
                            v-model="password"
                            type="password"
                            class="form-control"
                            id="userpassword"
                            :placeholder="$t('login.password.placeholder')"
                            :class="{
                              'is-invalid': submitted && $v.password.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.password.$error"
                            class="invalid-feedback d-block"
                          >
                            {{ $t("login.password.noinput") }}
                          </div>
                        </div>

                        <div class="custom-control custom-checkbox mb-4">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="rememberMe"
                          />
                          <label class="custom-control-label" for="rememberMe">
                            {{ $t("login.remember") }}
                          </label>
                        </div>

                        <button
                          class="btn btn-primary login-btn w-100"
                          type="submit"
                          :disabled="loginLoading"
                        >
                          <b-spinner v-if="loginLoading" small class="mr-2"></b-spinner>
                          {{ loginLoading ? $t("login.login") + "..." : $t("login.login") }}
                        </button>
                      </form>
                    </div>

                    <!-- 验证码输入 -->
                    <div
                      class="p-0 mt-4"
                      v-if="extendvoid && !qrcodelogin"
                      v-loading="loading"
                    >
                      <form
                        class="form-horizontal"
                        @submit.prevent="tryToLogInExtend"
                      >
                        <div
                          class="auth-code-inputs"
                          v-if="!ismobile"
                        >
                          <input
                            v-for="(_, idx) in 6"
                            :key="idx"
                            class="form-control auth-code-cell border-input"
                            maxlength="1"
                            type="tel"
                            inputmode="numeric"
                            :value="inputList[idx]"
                            @keyup="nextFocus($event, idx)"
                            @input="
                              (e) => {
                                const v = e.target.value.replace(/\D/g, '').slice(0, 1);
                                $set(inputList, idx, v);
                              }
                            "
                          />
                        </div>
                        <div v-if="ismobile">
                          <van-password-input
                            :value="authcodes"
                            :length="6"
                            :mask="false"
                            :focused="keyboard"
                            @focus="keyboard = true"
                          />
                          <van-number-keyboard
                            :show="keyboard"
                            @input="onInput"
                            @delete="onDelete"
                            @blur="keyboard = false"
                          />
                        </div>
                      </form>
                    </div>

          <div class="mt-5 pt-4 text-center login-footer">
            <p class="mb-0">
              © 2016 Shijiazhuang MOE Information Technology Co., Ltd
            </p>
            <p class="mb-0">
              © 2015 AICO Group Limited · © 2021 AICO CLOUD UK LTD
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-logo {
  max-width: 180px;
  height: auto;
}
.login-btn {
  &:disabled .spinner {
    display: inline-block;
  }
}
</style>
